import { useAuth } from "@/contexts/AuthContext";
import { CLUB } from "@/lib/club";

export default function Login() {
  const { loading, user } = useAuth();

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) return null;
  if (user) {
    window.location.href = "/dashboard";
    return null;
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] grid md:grid-cols-2" data-testid="login-page">
      {/* Left: form */}
      <div className="flex items-center justify-center p-10">
        <div className="w-full max-w-md">
          <img src={CLUB.logo} alt={CLUB.name} className="h-32 w-auto mb-6" data-testid="club-logo"/>
          <div className="overline mb-4" data-testid="brand-overline">{CLUB.tagline}</div>
          <h1 className="font-display text-5xl lg:text-6xl text-white leading-none">
            FERROVIARIOS<br /><span className="text-[#22d3ee]">PUENTE ALTO</span>
          </h1>
          <p className="text-[#A1A1AA] mt-6 max-w-sm">
            Plataforma oficial del club. Cuotas, calendario, playbook y fichas de jugadores — todo en un solo lugar.
          </p>

          <div className="divider-x my-8" />

          <button
            data-testid="login-google-button"
            onClick={handleLogin}
            className="btn-primary w-full flex items-center justify-center gap-3"
          >
            <GoogleIcon />
            <span>Iniciar sesión con Google</span>
          </button>

          <div className="mt-6 text-xs text-[#71717A] uppercase tracking-widest">
            Acceso exclusivo · Solo miembros del club
          </div>

          <div className="mt-10 grid grid-cols-3 gap-0 border border-[#27272A]" data-testid="club-branches">
            <Branch label="Tackle" sub="11 vs 11" accent="#22d3ee"/>
            <Branch label="Flag Masc." sub="5 vs 5" accent="#22d3ee"/>
            <Branch label="Flag Fem." sub="5 vs 5" accent="#22d3ee"/>
          </div>
        </div>
      </div>

      {/* Right: stadium image */}
      <div
        className="hidden md:block relative bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/28239821/pexels-photo-28239821.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
        }}
      >
        <div className="absolute inset-0 stadium-overlay" />
        <div className="absolute bottom-10 left-10 right-10">
          <div className="overline text-[#A1A1AA]">Tactical Operations</div>
          <div className="font-display text-4xl text-white mt-2 leading-none">
            DISCIPLINE · DRILLS · DOMINANCE
          </div>
        </div>
      </div>
    </div>
  );
}

const Branch = ({ label, sub, accent }) => (
  <div className="p-4 border-r border-[#27272A] last:border-r-0">
    <div className="overline text-[#71717A]">RAMA</div>
    <div className="font-display text-xl text-white mt-1 leading-none">{label.toUpperCase()}</div>
    <div className="text-[10px] uppercase tracking-widest mt-2" style={{ color: accent }}>{sub}</div>
  </div>
);

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill="#fff" d="M21.35 11.1H12v2.9h5.35c-.23 1.5-1.7 4.4-5.35 4.4-3.22 0-5.85-2.67-5.85-5.95s2.63-5.95 5.85-5.95c1.84 0 3.07.78 3.78 1.45l2.58-2.48C16.85 3.95 14.66 3 12 3 6.98 3 3 6.98 3 12s3.98 9 9 9c5.2 0 8.65-3.66 8.65-8.8 0-.6-.07-1.05-.15-1.5z"/>
  </svg>
);
